
import React from 'react';
import { motion } from 'framer-motion';
import { Search, FileCheck, Rocket } from 'lucide-react';

const Process = () => {
  const steps = [
    {
      icon: Search,
      title: 'Assess',
      description: 'We evaluate your current security posture and identify knowledge gaps'
    },
    {
      icon: FileCheck,
      title: 'Plan',
      description: 'Create a customized training and assessment roadmap for your team'
    },
    {
      icon: Rocket,
      title: 'Execute',
      description: 'Implement comprehensive training and continuous improvement programs'
    }
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white w-full overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="bg-gradient-to-r from-[#422680] via-[#660F56] to-[#F54952] bg-clip-text text-transparent">
              How It Works
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our proven 3-step process ensures your success
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 relative">
          {/* Connector Line - Only visible on MD+ screens */}
          <div className="hidden md:block absolute top-[3.5rem] left-0 w-full h-1 bg-gradient-to-r from-[#422680] via-[#F54952] to-[#422680] opacity-20" />
          
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.2 }}
                className="relative z-10"
              >
                <div className="text-center">
                  <div className="relative inline-block mb-6">
                    <div className="absolute -inset-4 bg-gradient-to-r from-[#422680] to-[#F54952] rounded-full blur-lg opacity-30"></div>
                    <div className="relative w-24 h-24 bg-gradient-to-br from-[#422680] via-[#660F56] to-[#F54952] rounded-full flex items-center justify-center border-4 border-white shadow-lg">
                      <Icon className="text-white" size={40} />
                    </div>
                  </div>
                  
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">
                    <span className="text-[#F54952]">0{index + 1}.</span> {step.title}
                  </h3>
                  <p className="text-gray-600 px-4">{step.description}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Process;
